(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bs-hosgeldin-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.currentScript && document.currentScript.parentElement;
  // currentScript trick doesn't work in {% javascript %} block reliably — fall back to querySelectorAll
  var popups = document.querySelectorAll('[data-bs-popup]');
  popups.forEach(function (el) { initPopup(el); });

  function initPopup(el) {
    if (el.__bsInit) return;
    el.__bsInit = true;

    var delay = parseInt(el.dataset.delay || '3', 10) * 1000;
    var cooldownMs = parseInt(el.dataset.cooldownDays || '14', 10) * 24 * 60 * 60 * 1000;

    var SEEN_KEY = 'bs-popup-seen-at';
    var SUB_KEY = 'bs-popup-subscribed';

    // Önce: form submit sonrası reload ise success'u göster ve dur
    if (maybeShowPostSubmit(el)) {
      // Click/keyboard close bağlamayı unutmayalım, o aşağıda zaten yapılıyor
    } else {
      if (localStorage.getItem(SUB_KEY) === 'true') return;
      var seenAt = parseInt(localStorage.getItem(SEEN_KEY) || '0', 10);
      if (seenAt && (Date.now() - seenAt) < cooldownMs) return;

      setTimeout(function () { openPopup(el); }, delay);
    }

    el.querySelectorAll('[data-bs-popup-close], [data-bs-popup-overlay]').forEach(function (x) {
      x.addEventListener('click', function () { closePopup(el); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && el.dataset.bsOpen === 'true') closePopup(el);
    });

    var form = el.querySelector('form.bs-popup__form');
    if (form) bindIframeForm(el, form);

    var copyBtn = el.querySelector('[data-bs-popup-copy]');
    if (copyBtn) copyBtn.addEventListener('click', function () { copyCode(el, copyBtn); });

    var retryBtn = el.querySelector('[data-bs-popup-retry]');
    if (retryBtn) retryBtn.addEventListener('click', function () { showStage(el, 'form'); });
  }

  function openPopup(el) {
    el.dataset.bsOpen = 'true';
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closePopup(el) {
    el.dataset.bsOpen = 'false';
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    localStorage.setItem('bs-popup-seen-at', String(Date.now()));
  }

  function showStage(el, stage) {
    el.querySelector('[data-bs-popup-form-stage]').hidden = (stage !== 'form');
    el.querySelector('[data-bs-popup-success-stage]').hidden = (stage !== 'success');
    el.querySelector('[data-bs-popup-error-stage]').hidden = (stage !== 'error');
  }

  function bindIframeForm(el, form) {
    // Client-side only: email'i localStorage'a kaydet + success göster.
    // (Shopify captcha zorunluluğu nedeniyle direkt submit yerine bu akış.)
    var btn = form.querySelector('[data-bs-popup-submit]');
    function handleSignup() {
      var emailInput = form.querySelector('input[type="email"]');
      if (!emailInput || !emailInput.value || !emailInput.checkValidity()) {
        if (emailInput) emailInput.reportValidity();
        return;
      }
      // Email listesini browser'da topla (istenirse sonra dışa aktarılır)
      try {
        var list = JSON.parse(localStorage.getItem('bs-popup-emails') || '[]');
        var entry = { email: emailInput.value.trim(), ts: new Date().toISOString() };
        if (!list.some(function(x){ return x.email === entry.email; })) list.push(entry);
        localStorage.setItem('bs-popup-emails', JSON.stringify(list));
      } catch(e) {}
      localStorage.setItem('bs-popup-subscribed', 'true');
      if (btn) { btn.disabled = true; btn.textContent = 'Hazırlanıyor...'; }
      setTimeout(function(){ showStage(el, 'success'); }, 350);
    }
    // Submit event (enter key vs.)
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      handleSignup();
      return false;
    }, true);
    // Button click
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        handleSignup();
      });
    }
  }

  // Reload sonrası success'u otomatik göster
  function maybeShowPostSubmit(el) {
    var qs = location.search || '';
    var pending = localStorage.getItem('bs-popup-pending');
    if (pending === '1' && qs.indexOf('customer_posted=true') > -1) {
      localStorage.removeItem('bs-popup-pending');
      localStorage.setItem('bs-popup-subscribed', 'true');
      // URL'i temizle (hash kalmasın, tekrar açıldığında trigger olmasın)
      try { history.replaceState(null, '', location.pathname); } catch(e) {}
      openPopup(el);
      showStage(el, 'success');
      return true;
    }
    return false;
  }

  function handleSubmit(e, el, form) {
    if (e && e.preventDefault) e.preventDefault();
    if (e && e.stopPropagation) e.stopPropagation();
    if (e && e.stopImmediatePropagation) e.stopImmediatePropagation();

    var emailInput = form.querySelector('input[type="email"]');
    if (!emailInput || !emailInput.value || !emailInput.checkValidity()) {
      if (emailInput) emailInput.reportValidity();
      return false;
    }

    var btn = form.querySelector('[data-bs-popup-submit]');
    var origText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Gönderiliyor...';

    var fd = new FormData(form);

    fetch(form.getAttribute('action'), {
      method: 'POST',
      body: fd,
      credentials: 'same-origin',
      redirect: 'follow',
      headers: { 'Accept': 'text/html,application/xhtml+xml' },
    }).then(function (res) {
      if (res.ok || res.status === 302 || res.status === 200 || res.type === 'opaqueredirect') {
        localStorage.setItem('bs-popup-subscribed', 'true');
        showStage(el, 'success');
      } else {
        throw new Error('HTTP ' + res.status);
      }
    }).catch(function (err) {
      var errBox = el.querySelector('[data-bs-popup-error-text]');
      if (errBox) errBox.textContent = 'Bir sorun oluştu: ' + (err.message || err);
      showStage(el, 'error');
    }).finally(function () {
      btn.disabled = false;
      btn.textContent = origText;
    });

    return false;
  }

  function copyCode(el, btn) {
    var code = el.querySelector('[data-bs-popup-code]').textContent.trim();
    var done = function () {
      btn.dataset.copied = 'true';
      var t = btn.textContent;
      btn.textContent = 'Kopyalandı!';
      setTimeout(function () { btn.textContent = t; btn.dataset.copied = 'false'; }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(function(){ fallback(); });
    } else {
      fallback();
    }
    function fallback() {
      var tmp = document.createElement('input');
      tmp.value = code;
      document.body.appendChild(tmp);
      tmp.select();
      try { document.execCommand('copy'); done(); } catch (e) {}
      document.body.removeChild(tmp);
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
